import React, { ReactNode } from "react";

import "./AlertModal.scss";

interface AlertModalProps {
  children?: ReactNode;
  onClose: () => void;
  title?: string;
  content?: string;
}

const AlertModal: React.FC<AlertModalProps> = ({
  children,
  onClose,
  title,
  content,
}) => {
  return (
    <div className="alert-modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          {/* <button className="modal-close" onClick={onClose}>
            Close
          </button> */}
        </div>
        <div className="modal-content">
          <h2>{title}</h2>
          <p dangerouslySetInnerHTML={{ __html: content || "" }}></p>
        </div>
        <div className="modal-btn-wrap">
          <div className="btn-wrap">
            <button
              style={{ fontSize: "1.8em", border: "none" }}
              onClick={() => {
                onClose();
              }}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
